var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSkipForward = function SvgSkipForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.032 20c-.65 0-1.183-.584-1.183-1.298v-6.288a1.558 1.558 0 0 1-.51.727l-7.945 6.5C3.628 20.27 3 19.971 3 18.98V5.02c0-.991.627-1.289 1.394-.661l7.945 6.5c.255.208.425.46.51.727V5.298c0-.714.533-1.298 1.183-1.298h1.901c.65 0 1.183.584 1.183 1.298v13.404c0 .714-.532 1.298-1.183 1.298h-1.9Z",
    fill: "currentColor"
  })));
};
export default SvgSkipForward;